module.exports = __webpack_public_path__ + "static/media/hire_qa.f8c4bc46.svg";